export default __webpack_public_path__ + "static/media/strategyChi4.a3901408.jpg";